<template>
  <div id="app">
    <div>
      <div id="designer"></div>
      <div id="viewer"></div>
    </div>
  </div>
</template>

<script>
const DEBUG = process.env.NODE_ENV == "development";
export default {
  name: "app",
  data() {
    return {
      mrt: "",
      api: "",
      method: "",
      reports: {
        rd1: {
          mrt: "reports/rd1.mrt",
          api: "reports/rd1",
          method: "get",
        },
        wr1: {
          mrt: "reports/wr1.mrt",
          api: "reports/wr1",
          method: "get",
        },
        cargo: {
          mrt: "reports/cargo.mrt",
          method: "get",
        },
        cr1: {
          mrt: "reports/cr1.mrt",
          api: "reports/cr1",
          method: "get",
        },
      },
      report: {},
      stimuleReport: {},
    };
  },
  computed: {
    isDesigner() {
      return process.env.VUE_APP_STIMULMODE == 1;
    },
  },
  beforeDestroy() {
    this.$setIsLoading(false);
    this.$setLayout("app-layout");
  },
  mounted: function() {
    this.log("Query", this.$route);
    this.log("Query", this.$route.query);
    this.$setLayout("simple-layout");
    this.addMethods();
    this.prepareVariables();
    this.$setIsLoading(true);
    this.requestForDataSource().then((res) => {
      this.log("Title", res.data.title);
      this.log("Decription", res.data.description);
      this.log("Datasource", res.data.data);
      var report = this.createReportInstance();
      report = this.addDatasource(report, res.data.data, "Report");
      let infoData = {
        title: res.data.title,
        description: res.data.description,
      };
      report = this.addDatasource(report, infoData, "Info");
      report = this.loadMRTFile(report);
      this.render(report);
    }).catch(e => {
      this.$router.go(-1)
    })
  },
  methods: {
    prepareVariables() {
      this.report = this.reports[this.$route.query.name];
      this.mrt = this.report.mrt;
      this.api = this.$route.query.api
        ? this.$route.query.api
        : this.report.api + this.$route.query.filters;
      this.method = this.report.method;
    },
    requestForDataSource() {
      return this.$persistClient(this.method, this.api);
    },
    createViewer() {
      return new window.Stimulsoft.Viewer.StiViewer(null, "StiViewer", false);
    },
    createOptions() {
      var options = new window.Stimulsoft.Designer.StiDesignerOptions();
      options.appearance.fullScreenMode = true;
      return options;
    },
    createDesigner() {
      var options = this.createOptions();
      return new window.Stimulsoft.Designer.StiDesigner(
        options,
        "StiDesigner",
        false
      );
    },
    createReportInstance() {
      return new window.Stimulsoft.Report.StiReport();
    },
    addDatasource(_report, _data, _name) {
      if (_data) {
        var dataSet = new Stimulsoft.System.Data.DataSet("datasourse");
        dataSet.readJson(_data);
        _report.regData(_name, "", dataSet);
      }
      return _report;
    },
    loadMRTFile(_report) {
      if (this.mrt) {
        _report.loadFile(this.mrt);
      }
      return _report;
    },
    render(_report) {
      this.log("Is Designer", this.isDesigner);
      if (this.isDesigner) {
        var designer = this.createDesigner();
        designer.report = _report;
        designer.renderHtml("designer");
      } else {
        var viewer = this.createViewer();
        viewer.report = _report;
        viewer.renderHtml("viewer");
      }
      this.$setIsLoading(false);
    },
    log(_event, _payload) {
      if (DEBUG)
        console.info(
          `%cDebug: STIMULSOFT`,
          "color: blue; font-weight: 600",
          "Event:",
          _event,
          "Payload:",
          _payload
        );
    },
    addMethods() {
      var getJalaliDate = function(dateTime) {
        if (dateTime)
          return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format(
            "jYYYY/jMM/jDD"
          );
        return moment().format("jYYYY/jMM/jDD");
      };

      Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
        "BitaFunctions",
        "ConvertTimes",
        "GetJalaliDate",
        "",
        "",
        String,
        "",
        [String],
        [""],
        [""],
        getJalaliDate
      );

      var getJalaliDateTime = function(dateTime) {
        if (dateTime)
          return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format(
            "jYYYY/jMM/jDD HH:mm:ss"
          );
        return moment().format("jYYYY/jMM/jDD HH:mm:ss");
      };

      Stimulsoft.Report.Dictionary.StiFunctions.addFunction(
        "BitaFunctions",
        "ConvertTimes",
        "GetJalaliDateTime",
        "",
        "",
        String,
        "",
        [String],
        [""],
        [""],
        getJalaliDateTime
      );
    },
  },
};
</script>

<style></style>
